import React from "react";
import { withStyles } from "@material-ui/core";
import { COLORS } from "../../../constant/colors";

const LinkText = ({ classes, text, onClick, additionalClasses = [] }) => (
  <a className={`${classes.linkText} ${additionalClasses.join(' ')}`} onClick={onClick}>{text}</a>
);

const LinkTextStyled = withStyles({
  linkText: {
    all: 'unset',
    cursor: "pointer",
    color: COLORS.fwdOrange,
    fontSize: 16,
    fontWeight: 700,
  },
})(LinkText);

export default LinkTextStyled;
